import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface LightingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Lighting: React.FC<LightingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [lighting, set_lighting] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Interior Finishes']?.['Lighting'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior Finishes': { ...b.values?.['Interior Finishes'], 'Lighting': v } } })
    );
    const label = 'Lighting';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(lighting)}
                />
            ) : (
                <MoneyBox
                    id={'lighting'}
                    allowNegative={false}
                    value={lighting}
                    onChange={(value) => set_lighting(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
